const translations = {
  en: {
    // Calendar Header
    calendar: "Calendar",
    advancedScheduling: "Advanced scheduling system with smart event management, vacation planning, productivity insights, and analytics",
    newEvent: "New Event",
    new: "New",
    share: "Share",

    // Statistics
    totalEvents: "Total Events",
    thisMonth: "This Month",
    todayEvents: "Today's Events",
    thisWeek: "This Week",
    upcoming: "Upcoming",
    completed: "Completed Events",
    overdue: "Overdue Events",
    weeklyHours: "Weekly Hours",
    meetings: "Meetings",
    deadlines: "Deadlines",
    vacationDays: "Vacation Days",
    productivity: "Productivity",
    fromLastMonth: "From last month",

    // To-Do List
    todoList: "To-Do List",
    addNewTask: "Add New Task",
    typeTaskHere: "Type your task here...",
    addTask: "Add Task",
    allTasks: "All Tasks",
    activeTasks: "Active",
    completedTasks: "Completed",
    noTasks: "No Tasks Yet",
    noTasksDescription: "Start adding tasks to stay organized",
    markComplete: "Mark Complete",
    deleteTask: "Delete Task",
    personalTasks: "Personal",
    workTasks: "Work",
    urgentTasks: "Urgent",
    taskProgress: "Progress",
    of: "of",
    tasksCompleted: "tasks completed",
    category: "Category",
    taskDescription: "Task Description",

    // Tasks — Assignment (Phase 1)
    tasks: "Tasks",
    myTasks: "My Tasks",
    assignedByMe: "Assigned By Me",
    newTask: "New Task",
    assignTo: "Assign to",
    assignToPlaceholder: "Search your direct reports...",
    noDirectReports: "You have no direct reports to assign tasks to.",
    dueDate: "Due Date",
    addDueDate: "Add due date",
    removeDueDate: "Remove due date",
    priorityLow: "Low",
    priorityNormal: "Normal",
    priorityHigh: "High",
    priorityUrgent: "Urgent",
    statusPending: "Pending",
    statusInProgress: "In Progress",
    statusCompleted: "Completed",
    statusCancelled: "Cancelled",
    taskTotal: "Total Tasks",
    taskInProgress: "Tasks In Progress",
    taskOverdue: "Overdue Tasks",
    taskCompletedCard: "Completed Tasks",
    assignedBy: "Assigned by",
    searchTasks: "Search tasks...",
    filterStatus: "Status",
    filterPriority: "Priority",
    filterAssignedBy: "Assigned By",
    allStatuses: "All Statuses",
    allPriorities: "All Priorities",
    allAssigners: "Everyone",
    personalOnly: "Personal",
    assignedToMeOnly: "Assigned to Me",
    startTask: "Start",
    completeTask: "Complete",
    cancelTask: "Cancel Task",
    editTask: "Edit",
    changeDueDate: "Change Due Date",
    changePriority: "Change Priority",
    taskHistory: "History",
    noTaskHistory: "No changes recorded yet.",
    noTasksFound: "No tasks match your filters.",
    taskTitle: "Title",
    taskTitlePlaceholder: "e.g. Prepare Payroll",
    taskDescriptionPlaceholder: "Optional details...",
    createTask: "Create Task",
    saveChanges: "Save Changes",
    confirmCancelTask: "Cancel this task? This can't be undone — the task will stop appearing as active for the assignee.",
    loadMore: "Load more",

    // Calendar Controls
    calendarControls: "Calendar Controls",
    searchEvents: "Search events...",

    // Event Types
    allEvents: "All Events",
    training: "Training",
    interviews: "Interviews",
    reviews: "Reviews",
    social: "Social",
    deadline: "Deadline",
    vacation: "Vacation",
    conferences: "Conferences",
    eventCategories: "Event Categories",

    // Upcoming Events
    upcomingEvents: "Upcoming Events",
    noUpcomingEvents: "No upcoming events",
    calendarClear: "Your calendar is clear for the coming week",

    // Quick Actions
    quickActions: "Quick Actions",
    shareCalendar: "Share Calendar",
    exportCalendar: "Export Calendar",

    // Event Modal
    createNewEvent: "Create New Event",
    editEvent: "Edit Event",
    viewEventDetails: "View Event Details",
    eventOrganizedBy: "Event organized by",
    updateEventDetails: "Update event details and settings",
    addNewEvent: "Add new",
    toYourCalendar: "to your calendar",
    organizedBy: "Organized by",
    youAreAttendee: "You are an attendee of this event",
    yourCurrentRSVP: "Your current RSVP",
    noResponse: "No response",
    updateResponse: "Use the buttons below to update your response",

    // Event Form Fields
    eventTitle: "Event Title",
    enterEventTitle: "Enter",
    title: "title",
    description: "Description",
    addVacationNotes: "Add vacation notes, contact info, or special instructions...",
    addProjectDetails: "Add project details, requirements, or delivery guidance...",
    addDetailedDescription: "Add a detailed description, agenda, notes, or meeting objectives...",

    // Date & Time
    startDate: "Start Date",
    date: "Date",
    endDate: "End Date",
    lastDayVacation: "Last day of vacation",
    extendedDeadline: "Extended deadline (optional)",
    multiDayEnd: "Multi-day event end date",
    startTime: "Start Time",
    dueTime: "Due Time",
    duration: "Duration",
    minutes: "Minutes",
    minute: "Minute",
    hour: "Hour",
    hours: "Hours",
    allDay: "All Day",
    endDateEarlier: "End date cannot be before start date. Please choose a valid end date.",

    // Event Properties
    eventType: "Event Type",
    priority: "Priority",
    lowPriority: "Low Priority",
    mediumPriority: "Medium Priority",
    highPriority: "High Priority",
    urgent: "Urgent",
    status: "Status",
    yourStatus: "Your Status",
    accepted: "Accepted",
    declined: "Declined",
    tentative: "Tentative",
    scheduled: "Scheduled",
    confirmed: "Confirmed",
    inProgress: "In Progress",
    cancelled: "Cancelled",
    postponed: "Postponed",

    // Location
    venue: "Venue",
    meetingLocation: "Meeting Location",
    location: "Location",
    conferenceVenue: "Conference center or venue name or address...",
    meetingRoom: "Meeting room or link or office location...",
    locationDetails: "Location details or address or link...",

    // Attendees
    eventAttendees: "Event Attendees",
    attendees: "Attendees",
    organizer: "Organizer",
    typeNameEmail: "Type name or email to search employees, or enter emails separated by commas",
    searchingFor: "Searching for",
    found: "found",
    availableEmployees: "Available Employees",
    loadingDirectory: "Loading employee directory...",
    noEmployeesFound: "No employees found for",
    typeEmailManually: "You can type email addresses manually",
    attendeesPlural: "attendees",
    attendee: "attendee",
    willReceiveInvitations: "will receive invitations",
    employeesAvailable: "employees available in directory",

    // Recurrence
    recurrence: "Recurrence (optional)",
    noRecurrence: "No recurrence",
    daily: "Daily",
    weekly: "Weekly",
    monthly: "Monthly",
    yearly: "Yearly",

    // Reminders
    enableReminders: "Enable reminders",
    reminders: "Reminders & Notifications",
    emailRemindersEnabled: "Email reminders enabled for this event",

    // Actions
    deleteEvent: "Delete event",
    close: "Close",
    cancel: "Cancel",
    updateEvent: "Update event",
    createEvent: "Create event",
    accept: "Accept",
    decline: "Decline",
    maybe: "Maybe",

    // Export Modal
    chooseFormat: "Choose export format and date range",
    exportFormat: "Export format",
    pdfReport: "PDF Report",
    formattedReport: "Formatted print report",
    excelFile: "Excel file",
    spreadsheetData: "Spreadsheet with event data",
    calendarFile: "Calendar File",
    importCalendars: "Import to other calendars",
    dateRange: "Date range",
    thisWeekRange: "This week",
    thisMonthRange: "This month",
    lastMonth: "Last month",
    thisQuarter: "This quarter",
    thisYear: "This year",
    allEventsRange: "All events",
    exporting: "Exporting...",
    export: "Export",

    // Share Modal
    shareWith: "Share your calendar with others",
    shareVia: "Share via",
    facebook: "Facebook",
    twitter: "Twitter",
    linkedin: "LinkedIn",
    whatsApp: "WhatsApp (link)",
    email: "Email",
    copyLink: "Copy link",
    linkCopied: "Link copied",
    linkCopiedMessage: "Calendar link copied to clipboard",

    // Notifications
    eventUpdated: "Event Updated",
    eventCreated: "Event Created",
    hasBeenUpdated: "has been updated successfully",
    hasBeenCreated: "has been created successfully",
    rsvpUpdated: "RSVP Updated",
    responseUpdated: "Your response has been updated to",
    eventDeleted: "Event Deleted",
    hasBeenDeleted: "has been deleted",
    deleteConfirm: "Delete event",
    viewEvent: "View Event",
    more: "more",
    today: "Today",
    tomorrow: "Tomorrow",
    event: "event",
    events: "events",

    // Error Messages
    loading: "Loading...",
    noUserSession: "No user session found",
    noEventsFound: "No events found",
    unableToLoad: "Unable to load calendar events",
    failedToSave: "Failed to save event",
    failedToDelete: "Failed to delete event",
    missingInfo: "Missing required information for RSVP update",
    failedToUpdate: "Failed to update RSVP status",
    unknownUser: "Unknown User",

    // Months
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December",

    // Days
    sun: "Sun",
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
  },

  ar: {
    // رأس التقويم
    calendar: "التقويم",
    advancedScheduling: "نظام جدولة متقدم مع إدارة ذكية للأحداث، تخطيط الإجازات، رؤى الإنتاجية، والتحليلات الشاملة",
    newEvent: "حدث جديد",
    new: "جديد",
    share: "مشاركة",

    // الإحصائيات
    totalEvents: "إجمالي الأحداث",
    thisMonth: "هذا الشهر",
    todayEvents: "أحداث اليوم",
    thisWeek: "هذا الأسبوع",
    upcoming: "القادمة",
    completed: "أحداث مكتملة",
    overdue: "أحداث متأخرة",
    weeklyHours: "ساعات الأسبوع",
    meetings: "الاجتماعات",
    deadlines: "المواعيد النهائية",
    vacationDays: "أيام الإجازة",
    productivity: "الإنتاجية",
    fromLastMonth: "من الشهر الماضي",

    // قائمة المهام
    todoList: "قائمة المهام",
    addNewTask: "إضافة مهمة جديدة",
    typeTaskHere: "اكتب مهمتك هنا...",
    addTask: "إضافة المهمة",
    allTasks: "كل المهام",
    activeTasks: "قيد التنفيذ",
    completedTasks: "مكتملة",
    noTasks: "لا توجد مهام",
    noTasksDescription: "ابدأ بإضافة مهام لتنظيم وقتك",
    markComplete: "تحديد كمكتملة",
    deleteTask: "حذف المهمة",
    personalTasks: "شخصية",
    workTasks: "العمل",
    urgentTasks: "عاجلة",
    taskProgress: "نسبة الإنجاز",
    of: "من",
    tasksCompleted: "مهام مكتملة",
    category: "الفئة",
    taskDescription: "وصف المهمة",

    // المهام — الإسناد (المرحلة الأولى)
    tasks: "المهام",
    myTasks: "مهامي",
    assignedByMe: "المهام اللي كلّفتها",
    newTask: "مهمة جديدة",
    assignTo: "إسناد إلى",
    assignToPlaceholder: "ابحث عن الموظفين تحتك...",
    noDirectReports: "مفيش موظفين تحتك تقدر تسند لهم مهام.",
    dueDate: "تاريخ الاستحقاق",
    addDueDate: "إضافة تاريخ استحقاق",
    removeDueDate: "إزالة تاريخ الاستحقاق",
    priorityLow: "منخفضة",
    priorityNormal: "عادية",
    priorityHigh: "عالية",
    priorityUrgent: "عاجلة",
    statusPending: "قيد الانتظار",
    statusInProgress: "قيد التنفيذ",
    statusCompleted: "مكتملة",
    statusCancelled: "ملغاة",
    taskTotal: "إجمالي المهام",
    taskInProgress: "مهام قيد التنفيذ",
    taskOverdue: "مهام متأخرة",
    taskCompletedCard: "مهام مكتملة",
    assignedBy: "أُسندت بواسطة",
    searchTasks: "ابحث في المهام...",
    filterStatus: "الحالة",
    filterPriority: "الأولوية",
    filterAssignedBy: "المُسنِد",
    allStatuses: "كل الحالات",
    allPriorities: "كل الأولويات",
    allAssigners: "الكل",
    personalOnly: "شخصية",
    assignedToMeOnly: "مُسندة لي",
    startTask: "بدء",
    completeTask: "إنهاء",
    cancelTask: "إلغاء المهمة",
    editTask: "تعديل",
    changeDueDate: "تغيير تاريخ الاستحقاق",
    changePriority: "تغيير الأولوية",
    taskHistory: "السجل",
    noTaskHistory: "لا توجد تغييرات مسجلة بعد.",
    noTasksFound: "لا توجد مهام مطابقة للفلاتر.",
    taskTitle: "العنوان",
    taskTitlePlaceholder: "مثال: تجهيز الرواتب",
    taskDescriptionPlaceholder: "تفاصيل إضافية (اختياري)...",
    createTask: "إنشاء المهمة",
    saveChanges: "حفظ التغييرات",
    confirmCancelTask: "إلغاء هذه المهمة؟ لا يمكن التراجع عن هذا — ستتوقف عن الظهور كمهمة نشطة للموظف.",
    loadMore: "تحميل المزيد",

    // أدوات التقويم
    calendarControls: "أدوات التقويم",
    searchEvents: "البحث عن الأحداث...",

    // أنواع الأحداث
    allEvents: "كل الأحداث",
    training: "التدريب",
    interviews: "المقابلات",
    reviews: "المراجعات",
    social: "الاجتماعية",
    deadline: "الموعد النهائي",
    vacation: "الإجازة",
    conferences: "المؤتمرات",
    eventCategories: "فئات الأحداث",

    // الأحداث القادمة
    upcomingEvents: "الأحداث القادمة",
    noUpcomingEvents: "لا توجد أحداث قادمة",
    calendarClear: "تقويمك خالٍ للأسبوع القادم",

    // الإجراءات السريعة
    quickActions: "إجراءات سريعة",
    shareCalendar: "مشاركة التقويم",
    exportCalendar: "تصدير التقويم",

    // نافذة الحدث
    createNewEvent: "إنشاء حدث جديد",
    editEvent: "تعديل الحدث",
    viewEventDetails: "عرض تفاصيل الحدث",
    eventOrganizedBy: "الحدث منظم من قبل",
    updateEventDetails: "تحديث تفاصيل وإعدادات الحدث",
    addNewEvent: "إضافة",
    toYourCalendar: "إلى تقويمك",
    organizedBy: "منظم من قبل",
    youAreAttendee: "أنت حاضر في هذا الحدث",
    yourCurrentRSVP: "ردك الحالي",
    noResponse: "لا يوجد رد",
    updateResponse: "استخدم الأزرار أدناه لتحديث ردك",

    // حقول نموذج الحدث
    eventTitle: "عنوان الحدث",
    enterEventTitle: "أدخل",
    title: "عنوان",
    description: "الوصف",
    addVacationNotes: "أضف ملاحظات الإجازة أو معلومات الاتصال أو تعليمات خاصة...",
    addProjectDetails: "أضف تفاصيل المشروع أو المتطلبات أو إرشادات التسليم...",
    addDetailedDescription: "أضف وصفاً مفصلاً أو جدول أعمال أو ملاحظات أو أهداف الاجتماع...",

    // التاريخ والوقت
    startDate: "تاريخ البداية",
    date: "التاريخ",
    endDate: "تاريخ النهاية",
    lastDayVacation: "آخر يوم من الإجازة",
    extendedDeadline: "موعد نهائي ممتد (اختياري)",
    multiDayEnd: "تاريخ انتهاء حدث متعدد الأيام",
    startTime: "وقت البداية",
    dueTime: "وقت الاستحقاق",
    duration: "المدة",
    minutes: "دقائق",
    minute: "دقيقة",
    hour: "ساعة",
    hours: "ساعات",
    allDay: "طوال اليوم",
    endDateEarlier: "لا يمكن أن يكون تاريخ النهاية قبل تاريخ البداية. يرجى اختيار تاريخ نهاية صالح.",

    // خصائص الحدث
    eventType: "نوع الحدث",
    priority: "الأولوية",
    lowPriority: "أولوية منخفضة",
    mediumPriority: "أولوية متوسطة",
    highPriority: "أولوية عالية",
    urgent: "عاجل",
    status: "الحالة",
    yourStatus: "حالتك",
    accepted: "مقبول",
    declined: "مرفوض",
    tentative: "مؤقت",
    scheduled: "مجدول",
    confirmed: "مؤكد",
    inProgress: "قيد التنفيذ",
    cancelled: "ملغى",
    postponed: "مؤجل",

    // الموقع
    venue: "المكان",
    meetingLocation: "موقع الاجتماع",
    location: "الموقع",
    conferenceVenue: "مركز المؤتمرات أو اسم المكان أو العنوان...",
    meetingRoom: "غرفة الاجتماع أو الرابط أو موقع المكتب...",
    locationDetails: "تفاصيل الموقع أو العنوان أو الرابط...",

    // الحضور
    eventAttendees: "حضور الحدث",
    attendees: "الحضور",
    organizer: "المنظم",
    typeNameEmail: "اكتب الاسم أو البريد الإلكتروني للبحث عن الموظفين، أو أدخل عناوين البريد مفصولة بفواصل",
    searchingFor: "البحث عن",
    found: "تم العثور",
    availableEmployees: "الموظفون المتاحون",
    loadingDirectory: "جارٍ تحميل دليل الموظفين...",
    noEmployeesFound: "لم يتم العثور على موظفين لـ",
    typeEmailManually: "يمكنك كتابة عناوين البريد الإلكتروني يدوياً",
    attendeesPlural: "حضور",
    attendee: "حاضر",
    willReceiveInvitations: "سيتلقون الدعوات",
    employeesAvailable: "موظف متاح في الدليل",

    // التكرار
    recurrence: "التكرار (اختياري)",
    noRecurrence: "لا يوجد تكرار",
    daily: "يومي",
    weekly: "أسبوعي",
    monthly: "شهري",
    yearly: "سنوي",

    // التذكيرات
    enableReminders: "تفعيل التذكيرات",
    reminders: "التذكيرات والإشعارات",
    emailRemindersEnabled: "تم تفعيل تذكيرات البريد الإلكتروني لهذا الحدث",

    // الإجراءات
    deleteEvent: "حذف الحدث",
    close: "إغلاق",
    cancel: "إلغاء",
    updateEvent: "تحديث الحدث",
    createEvent: "إنشاء الحدث",
    accept: "قبول",
    decline: "رفض",
    maybe: "ربما",

    // نافذة التصدير
    chooseFormat: "اختر تنسيق التصدير والنطاق الزمني",
    exportFormat: "تنسيق التصدير",
    pdfReport: "تقرير PDF",
    formattedReport: "تقرير منسق للطباعة",
    excelFile: "ملف Excel",
    spreadsheetData: "جدول بيانات مع بيانات الأحداث",
    calendarFile: "ملف التقويم",
    importCalendars: "استيراد إلى تقويمات أخرى",
    dateRange: "النطاق الزمني",
    thisWeekRange: "هذا الأسبوع",
    thisMonthRange: "هذا الشهر",
    lastMonth: "الشهر الماضي",
    thisQuarter: "هذا الربع",
    thisYear: "هذا العام",
    allEventsRange: "كل الأحداث",
    exporting: "جارٍ التصدير...",
    export: "تصدير",

    // نافذة المشاركة
    shareWith: "شارك تقويمك مع الآخرين",
    shareVia: "مشاركة عبر",
    facebook: "فيسبوك",
    twitter: "تويتر",
    linkedin: "لينكدإن",
    whatsApp: "واتساب",
    email: "البريد الإلكتروني",
    copyLink: "نسخ الرابط",
    linkCopied: "تم نسخ الرابط",
    linkCopiedMessage: "تم نسخ رابط التقويم إلى الحافظة",

    // الإشعارات
    eventUpdated: "تم تحديث الحدث",
    eventCreated: "تم إنشاء الحدث",
    hasBeenUpdated: "تم تحديثه بنجاح",
    hasBeenCreated: "تم إنشاؤه بنجاح",
    rsvpUpdated: "تم تحديث الرد",
    responseUpdated: "تم تحديث ردك إلى",
    eventDeleted: "تم حذف الحدث",
    hasBeenDeleted: "تم حذفه",
    deleteConfirm: "حذف الحدث",
    viewEvent: "عرض الحدث",
    more: "المزيد",
    today: "اليوم",
    tomorrow: "غدًا",
    event: "حدث",
    events: "أحداث",

    // رسائل الخطأ
    loading: "جارٍ التحميل...",
    noUserSession: "لم يتم العثور على جلسة مستخدم",
    noEventsFound: "لم يتم العثور على أحداث",
    unableToLoad: "تعذر تحميل أحداث التقويم",
    failedToSave: "فشل في حفظ الحدث",
    failedToDelete: "فشل في حذف الحدث",
    missingInfo: "معلومات مطلوبة مفقودة لتحديث الرد",
    failedToUpdate: "فشل في تحديث حالة الرد",
    unknownUser: "مستخدم غير معروف",

    // الأشهر
    january: "يناير",
    february: "فبراير",
    march: "مارس",
    april: "أبريل",
    may: "مايو",
    june: "يونيو",
    july: "يوليو",
    august: "أغسطس",
    september: "سبتمبر",
    october: "أكتوبر",
    november: "نوفمبر",
    december: "ديسمبر",

    // الأيام
    sun: "الأحد",
    mon: "الإثنين",
    tue: "الثلاثاء",
    wed: "الأربعاء",
    thu: "الخميس",
    fri: "الجمعة",
    sat: "السبت",
  }
};

export default translations;
